import { ref } from 'vue'

const isDragging = ref(false)

interface DragEvt {
  originalEvent?: Event
  item?: Element
}

function startDrag(evt?: DragEvt) {
  isDragging.value = true
  document.documentElement.classList.add('is-dragging')

  const nativeEvt = evt?.originalEvent as MouseEvent | undefined
  const dragEl = evt?.item as HTMLElement | undefined
  if (!nativeEvt || !dragEl) return

  // Where the cursor was within the original element at drag start
  const rect = dragEl.getBoundingClientRect()
  const clickOffsetX = nativeEvt.clientX - rect.left
  const clickOffsetY = nativeEvt.clientY - rect.top

  // Sortable positions the fallback clone at the original element's top-left.
  // Shift it with a CSS transform so the chip center lands on the cursor.
  // Sortable only ever updates left/top on mousemove — never transform — so
  // this offset is preserved correctly for the entire drag.
  requestAnimationFrame(() => {
    const clone = document.querySelector('.drag-cursor--chip') as HTMLElement | null
    if (!clone) return
    const { width, height } = clone.getBoundingClientRect()
    clone.style.transform = `translate(${clickOffsetX - width / 2}px, ${clickOffsetY - height / 2}px) rotate(1.5deg)`
  })
}

function endDrag() {
  isDragging.value = false
  document.documentElement.classList.remove('is-dragging')
}

export function useDragState() {
  return { isDragging, startDrag, endDrag }
}
